export const HOST_API = 'https://social-media.adityakrshnn.workers.dev/';
export const LOCALHOST_API = 'http://127.0.0.1:8787/';